import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import axios from 'axios';
import { CONFIG, CONFIG_UTIL } from '../../../../config';
import utilManagement from '../../../../apis/utilManagement';

class Redis extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    handleClickProgram = async () =>{
        console.log('PP');
        const eksReset = await utilManagement.post(CONFIG_UTIL.UTIL_INVALIDATE_REDISL,{
            ['cacheType']: 'program'
        })
        .catch(function(error) {
            console.log('kelas error '+error)
        });
    }
    handleClickProf = async () =>{
        console.log('PC')
        const eksReset = await utilManagement.post(CONFIG_UTIL.UTIL_INVALIDATE_REDISL,{
            ['cacheType']: 'program-detail'
        })
        .catch(function(error) {
            console.log('kelas error '+error)
        });
    }
    
    render() { 
        return ( 
            <div>
                <button onClick={this.handleClickProgram}>
                    Program
                </button>
                <button onClick={this.handleClickProf}>
                    Profil
                </button>
            </div>
         );
    }
}
 
const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Redis)